// EDITABLE OFFER + STORE SETTINGS
// Values in [BRACKETS] are placeholders — replace them with confirmed values before publishing.
export const site = {
  productName: 'Physical Education Ready',
  shortName: 'PE Ready',
  // Only the button inside the offer section links to checkout.
  // Every other CTA scrolls down to the offer section.
  checkoutUrl: 'https://pe-ready.impultienda.ar/checkout',
  offerAnchor: '#offer',
  supportEmail: '[SUPPORT EMAIL]',
  year: '2026',
  regularPrice: '$294',
  discount: '91',
  currentPrice: '$27',
  currency: 'USD',
  // Value breakdown shown inside the offer card
  valueVolumes: '$197',
  valueBonuses: '$97',
  totalValue: '$294',
  guaranteeDays: '30',
  // Set to false to hide the testimonial section cleanly until verified reviews exist.
  showTestimonials: true,
  legalLinks: [
    { label: 'Terms and Conditions', href: '#terms' },
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Refund Policy', href: '#refunds' },
    { label: 'License Terms', href: '#license' },
    { label: 'Contact', href: '#contact' },
  ],
  heroImage: 'https://cdn.magicpatterns.com/uploads/hGCcHJuovxF8Vea4Gzpq4u/WhatsApp_Image_2026-08-06_at_16.23.38-Photoroom.png',
  heroImageAlt:
    'Physical Education Ready system: five Elementary volumes, five Secondary volumes, digital lesson materials on desktop, tablet and phone, five bonus workbooks, and PE equipment',
}

export const CTA_LABEL = 'GET PHYSICAL EDUCATION READY'
export const CTA_MICROCOPY = 'Instant digital access • One-time payment • Lifetime access'
